/*
 * participantList.js 30.11.18
 *
 * (c) 2018 ergovia GmbH
 */
import {UPDATE_PARTICIPANT_LIST} from '../actions/types';

const participantList = (state = [], action) => {

    if (action.type === UPDATE_PARTICIPANT_LIST) {
        return action.list.slice();
    }

    return state.slice();
};

export default participantList;



// WEBPACK FOOTER //
// ./src/de/ergovia/reducers/participantList.js